import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Shows only liters in order creation unit of admixtures
 */
@Injectable()
export class CancelActionBlkAdt implements IFlagFeature {
  name = Features.CANCEL_ACTION_BLK_ADT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
